import { render, staticRenderFns } from "./RegisterCounseling.vue?vue&type=template&id=bbac7e10&scoped=true&"
import script from "./RegisterCounseling.vue?vue&type=script&lang=ts&"
export * from "./RegisterCounseling.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCounseling.vue?vue&type=style&index=0&id=bbac7e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbac7e10",
  null
  
)

export default component.exports